import React, { FC, useState, useMemo } from 'react';

import {
  CollapseHeaderContentWrapper,
  CollapseHeaderLabel,
  CollapseHeaderSubLabel,
  RadioGroupContainer,
} from '@components/views/components/listing/drawer/ResponsiveListingFilterAndSortStyle';
import { StyledFlightFilterDrawer } from '@components/views/flight/listing/ListingFilter/ListingFilterStyle';
import CustomIcon from '@components/utils/CustomIcon';
import { ArrowDownSLine } from '@assets/icons';
import RadioGroup from '@components/RadioGroup';

import ResponsiveApplyButton from './ResponsiveApplyButton/ResponsiveApplyButton';

interface ResponsiveListingSortInterface {
  data: Array<{
    id: string | number;
    label: string;
    disabled?: boolean;
  }>;
  activeKey: string;
  handleTabClick: (key: string) => void;
}

const ResponsiveListingSort: FC<ResponsiveListingSortInterface> = ({
  data,
  handleTabClick,
  activeKey,
}) => {
  const [activeSortId, setActiveSortId] = useState(activeKey);
  const [isShowModal, setIsShowModal] = useState(false);

  const activeSortLabel = useMemo(() => {
    return data?.find((d) => d.id === activeKey)?.label;
  }, [activeKey, data]);

  const handleApplySort = () => {
    setIsShowModal(false);
    handleTabClick(activeSortId);
  };

  return (
    <>
      <CollapseHeaderContentWrapper>
        <CollapseHeaderLabel>Sıralama:</CollapseHeaderLabel>
        <CollapseHeaderSubLabel onClick={() => setIsShowModal(true)}>
          {activeSortLabel}{' '}
          <CustomIcon
            icon={ArrowDownSLine}
            paletteColor='grey1100'
            fontSize={24}
          />
        </CollapseHeaderSubLabel>
      </CollapseHeaderContentWrapper>
      <StyledFlightFilterDrawer
        title='Sıralama'
        open={isShowModal}
        onClose={() => setIsShowModal((prevState) => !prevState)}
        placement='top'
        footer={
          <ResponsiveApplyButton title='Uygula' onClick={handleApplySort} />
        }
      >
        <RadioGroupContainer>
          <RadioGroup
            options={data}
            direction='column'
            getLabel={(option) => option.label}
            getValue={(option) => option.id}
            selectedIndex={data.findIndex((d) => d.id === activeSortId)}
            onChange={setActiveSortId}
          />
        </RadioGroupContainer>
      </StyledFlightFilterDrawer>
    </>
  );
};

export default ResponsiveListingSort;
